import { render, staticRenderFns } from "./DynamicCard.vue?vue&type=template&id=4fd023fb"
import script from "./DynamicCard.vue?vue&type=script&lang=js"
export * from "./DynamicCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports